import clsx from 'clsx'
import React from 'react'
import { useSelector } from 'react-redux'

import AutofarmImage from '../../assets/imgs/autofarm.svg'
import ArweaveImage from '../../assets/imgs/arweave.svg'
import OneInchImage from '../../assets/imgs/one-inch.svg'
import DYDXImage from '../../assets/imgs/dydx.svg'
import UnicryptImage from '../../assets/imgs/unicrypt.svg'
import OpenseaImage from '../../assets/imgs/opensea.svg'
import { DashboardLayout, Loader, Select } from '../../components'
import { isDesktop } from '../../utils'

import './Apps.scss'

const OPTIONS = [
   { value: 'history', title: 'History' },
   { value: 'new', title: 'New' },
   { value: 'exchanges', title: 'Exchanges' },
   { value: 'lending', title: 'Lending' },
   { value: 'skating', title: 'Skating' },
   { value: 'yield-farming', title: 'Yield Farming' },
   { value: 'all', title: 'All' },
]

const Apps = () => {
   const { isDarkTheme } = useSelector(state => state.theme)

   const [apps, setApps] = React.useState([])
   const [isLoading, setIsLoading] = React.useState(true)
   const [type, setType] = React.useState(OPTIONS[0])

   React.useEffect(() => {
      ;(async () => {
         try {
            // fetch apps here
            setApps([
               {
                  id: 1,
                  name: 'Autofarm',
                  image: AutofarmImage,
                  description:
                     'Cross-chain yield aggregator that enables users to get the return assets from yield farming pools by simply staking in Autofarm vaults.',
               },
               {
                  id: 2,
                  name: 'Aave',
                  image: ArweaveImage,
                  description:
                     'Aave is an Open Source and Non-Custodial protocol to earn interest on deposits and borrow assets.',
               },
               {
                  id: 3,
                  name: '1inch',
                  image: OneInchImage,
                  description:
                     'DeFi / DEX aggregator with the most liquidity and the best rates on Ethereum and Binance Smart Chain',
               },
               {
                  id: 4,
                  name: 'dYdX',
                  image: DYDXImage,
                  description:
                     'Trade Perpetuals on the most powerful open trading platform, backed by @a16z, @polychain, and Three Arrows Capital.',
               },
               {
                  id: 5,
                  name: 'Unicrypt',
                  image: UnicryptImage,
                  description:
                     'Unicrypt provides an ever-growing suite of decentralized services. The objective is to bring value to the DeFi space as a whole by delivering',
               },
               {
                  id: 6,
                  name: 'OpenSea',
                  image: OpenseaImage,
                  description:
                     'A peer-to-peer marketplace for rare digital items and crypto collectibles. Buy, sell, auction, and discover CryptoKitties, Decentraland.',
               },
            ])
         } catch (err) {
            console.log(err)
         } finally {
            setIsLoading(false)
         }
      })()
   }, [])

   if (isDesktop()) {
      return (
         <DashboardLayout>
            {isLoading ? (
               <Loader />
            ) : (
               <div
                  className={clsx(
                     'DesktopApps',
                     isDarkTheme && 'DesktopApps--dark'
                  )}
               >
                  <header className="DesktopApps__header">
                     <h4 className="DesktopApps__header-heading">Dapps</h4>
                     <Select
                        className="DesktopApps__header-select"
                        current={type}
                        options={OPTIONS}
                        onChange={selectedOption => setType(selectedOption)}
                        isDarkTheme={isDarkTheme}
                     />
                  </header>
                  <section className="DesktopApps__list">
                     {apps.map(app => (
                        <div className="DesktopApps__list-card" key={app.id}>
                           <div className="DesktopApps__list-card-top">
                              <img
                                 className="DesktopApps__list-card-top-img"
                                 src={app.image}
                                 alt={app.name}
                              />
                              <h3 className="DesktopApps__list-card-top-name">
                                 {app.name}
                              </h3>
                           </div>
                           <p className="DesktopApps__list-card-description">
                              {app.description}
                           </p>
                        </div>
                     ))}
                  </section>
               </div>
            )}
         </DashboardLayout>
      )
   }

   if (isLoading) return <Loader />
   return (
      <DashboardLayout className={clsx('Apps', isDarkTheme && 'Apps--dark')}>
         <header className="Apps__header">
            <h4 className="Apps__header-heading">Dapps</h4>
            <Select
               className="Apps__header-select"
               current={type}
               options={OPTIONS}
               isDarkTheme={isDarkTheme}
               onChange={selectedOption => setType(selectedOption)}
            />
         </header>
         <section className="Apps__list">
            {apps.map(app => (
               <div className="Apps__list-card" key={app.id}>
                  <img
                     className="Apps__list-card-img"
                     src={app.image}
                     alt={app.name}
                  />
                  <div className="Apps__list-card-content">
                     <h3 className="Apps__list-card-content-name">
                        {app.name}
                     </h3>
                     <p className="Apps__list-card-content-description">
                        {app.description}
                     </p>
                  </div>
               </div>
            ))}
         </section>
      </DashboardLayout>
   )
}

export default Apps
